import { CancelButton, EditButton } from '@core/components/Buttons';
import { CustomExpandedPanel } from '@core/components/CustomExpandedPanel';
import { SimpleDialog, SimpleDialogContent } from '@core/components/Dialog';
import { permissaoUtils } from '@core/util/permissaoUtil';
import React, { useState } from 'react';
import { FaShippingFast } from 'react-icons/fa';
import { TransportadoraAction } from '../../store/transportadoraAction';
import { useTransportadora } from '../../store/transportadoraContext';
import ContatoPanel from './ContatoPanel';
import DadosGeraisPanel from './DadosGeraisPanel';
import EnderecoPanel from './EnderecoPanel';

function TransportadoraVisualizacaoModal() {
  const [state, dispatch] = useTransportadora();

  const handleCancelar = () => dispatch(TransportadoraAction.fecharModalVisualizacao());
  const handleEditar = () => dispatch(TransportadoraAction.setEditarRegistro(state.registro));

  return (
    <SimpleDialog open={state.visualizar} onClose={handleCancelar}>
      <SimpleDialogContent
        header={{
          title: 'Cadastro de transportadora',
          icon: <FaShippingFast />,
          toolbar: (
            <>
              <CancelButton onClick={handleCancelar}>Fechar</CancelButton>
              {permissaoUtils.transportadora().editar && <EditButton onClick={handleEditar}>Editar</EditButton>}
            </>
          ),
        }}
        content={<TransportadoraVisualizacaoModalContent transportadora={state.registro} />}
        contentStyle={{ padding: 0 }}
      />
    </SimpleDialog>
  );
}

function TransportadoraVisualizacaoModalContent({ transportadora }) {
  const [expanded, setExpanded] = useState('dadosGerais');

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <>
      <CustomExpandedPanel
        title="Dados gerais"
        expanded={expanded === 'dadosGerais'}
        onChange={handleChange('dadosGerais')}
      >
        <DadosGeraisPanel transportadora={transportadora} />
      </CustomExpandedPanel>
      <CustomExpandedPanel title="Endereço" expanded={expanded === 'endereco'} onChange={handleChange('endereco')}>
        <EnderecoPanel transportadora={transportadora} />
      </CustomExpandedPanel>
      <CustomExpandedPanel title="Contato" expanded={expanded === 'contato'} onChange={handleChange('contato')}>
        <ContatoPanel transportadora={transportadora} />
      </CustomExpandedPanel>
    </>
  );
}

export default TransportadoraVisualizacaoModal;
